export default "__VITE_ASSET__395a8863__"